export const getClassSizeCardText = length => (length <= 6 ? 'big' : length <= 30 ? 'medium' : 'small')
